import React, { useState, useEffect } from 'react'

import {
	HashRouter as Router, 
	Routes, 
	Route, 
	Link,
	useParams, 
  useSearchParams
  } from "react-router-dom";

// import { makeStyles } from '@material-ui/core';

import Loading from './components/Loading'
import SelectBox  from './components/SelectBox';
import Results from './components/Results'
import EventSelect from './components/EventSelect';

// const styles = makeStyles({
//   main: {
//     display: 'flex', 
//     height: '100%', 
//     justifyContent: 'center'
//   }, 
//   mainContainer: {
//     display: 'flex',
//     flexGrow: 1, 
//     flexDirection: 'column', 
//     overflow: 'hidden', 
//     position: 'relative', 
//     maxHeight: '100%', 
//   }, 
//   selectContainer: {
//     display: 'flex', 
//     flexDirection: 'column'
//   }
// })

function App() {
  return (
    <Router>
      <Routes>
        <Route exact path="/" element={ <Home /> } />
        <Route path="/:prov/:year" element={<Main/>} />
        <Route path="/:prov/:year/:municipality" element={<Main/>} />
        <Route path="/:prov/:year/:municipality/:officeevent" element={<Main/>} />
      </Routes>
	  </Router>
  );
}

const Main = () => {
  const [data, setData] = useState({
    results: null, 
    cityList: null
  });
  const [selectedCity, setSelectedCity] = useState('');
  const [selectedEvent, setSelectedEvent] = useState('');
  const [selectedContests, setContests] = useState({
    officeList: [], 
    contests: [], 
    events: []
  });

  const {prov, year, municipality, officeevent} = useParams()
  const [searchParams] = useSearchParams();
  const amp = searchParams.get("amp");

  useEffect(() => {
    getStaticData();
    window.sendMessage({
      height: 300, 
      isAmp: amp ? amp : false
    }) 
    let interval = setInterval(()=>{
      getData();
    }, 30000)
    return () => {
      console.log('ummount')
      clearInterval(interval)
    }
  }, [])
  
  const getData = () => {
    console.log('fetching data...')
    fetch(`data/${prov}/${year}/results.json`, {cache: 'no-cache'})
      .then(res=>{
        if (res.ok) {
          return res.json()
        }}
      )
      .then(json=>{
        setData(prevData=>({
          ...prevData, 
          results: json
        }))
      })
      .catch(e=>{
        console.log(e)
      })
  }

  const getStaticData = () => {
    try {
      Promise.all([
        fetch(`data/${prov}/${year}/results.json`, {cache: 'no-cache'})
        .then(res=>{
          if (res.ok) {
            return res.json()
          }
          console.log('res not ok')
        })
        .catch(e=>{
          console.log('error fetching results')
        }), 
        fetch(`data/${prov}/${year}/cityList.json`)
        .then(res=>{
          if(res.ok) {
            return res.json()
          }
        })
        .catch(e=> {
          console.log('error fetching cityList')
        })
      ]).then(res=>{
        if (municipality) {
          let testCity = res[1].cityList.find(city=>city.toLowerCase().replace(/[^a-zA-Z0-9]/g, "") === municipality.toLowerCase().replace(/[^a-zA-Z0-9]/g, ""))
          if (testCity) {
            // console.log('res', {results: res[0], cityList: res[1]})
            // getContestList(testCity, {results: res[0], cityList: res[1]})
            setSelectedCity(testCity)
          }
        }
        setData(prevdata=>({
            ...prevdata, 
            results: res[0], 
            cityList: res[1]
          })
        )
        
      })
    } catch (e) {
      console.log(e, 'error fetching data')
    }
  }

  useEffect(() => {

    if (data.cityList) {
      if (selectedCity) {
        console.log('useEffect', data)
        getContestList(selectedCity)
      }
    }
  }, [data])

  useEffect(()=> {
    try {
      if (selectedCity) {
        // let height = document.getElementById('widget-main').scrollHeight
        setTimeout(()=>{
          let resultsHeight = document.getElementById('scroll').scrollHeight
          let selectsHeight = document.getElementById('selectBox').scrollHeight
          let height = resultsHeight + selectsHeight + 30
          console.log('sendMessage', resultsHeight, height, amp)
          window.sendMessage({
            height: height, 
            city: selectedCity, 
            isAmp: amp ? amp : false
          })  
        }, 50)
      }
    } catch (e) {
      console.log(e)
    }
  }, [selectedCity,selectedEvent])



  const getContestList = (city, dataset=data) => {
    try {
      if (dataset.results.ElectionPlaylist) {
      let contests = dataset.results.ElectionPlaylist.contest.filter(event=>{
        if (event.area.name.replace(' county', '').replace('City of ', '').toLowerCase() === city.replace(' county', '').replace('City of ', '').toLowerCase()) {
          return true
        } else if (event.area.name.toLowerCase().includes(city.toLowerCase())) {
          return true
        } else if (event.area.name.toLowerCase() === city.toLowerCase() && city !== "Alberta") {
          return true
        } else if (city === 'City of Red Deer' && event.area.name === 'Red Deer') {
          return true
        } else if (city === 'City of Calgary' && event.area.name.toLowerCase().includes('calgary')) {
          return true
        } else if (city === 'City of Edmonton' && event.event.name.toLowerCase().includes('edmonton')){
          return true
        } else if (city === 'Strathcona County' && event.event.name === "2021 Strathcona General Election") {
          return true
        } else if (city === 'Montréal Mayor' && event.area.name === "Montréal") {
          return true
        } else if (city.toLowerCase().replace(/[^\w\s]/gi, '') === event.event.name.toLowerCase().replace(/[^\w\s]/gi, '')) {
          return true
        } else if (city.toLowerCase().replace(/[^\w\s]/gi, '') === event.area.name.toLowerCase().replace(/[^\w\s]/gi, '') && event.area.name !== "Montréal" && event.event.name !== "Montérégie") {
          return true
        } else if (data.cityList[`wardList_${city.toLowerCase()}`] !== undefined) {
          if (data.cityList[`wardList_${city.toLowerCase()}`].includes(event.area.name)) {
            return true
          }
        }
        else {
          return false
        }
      })
      let office = []
      if (contests) {
        contests.map(contest=>{
          if (office.includes(contest.office.name)) {
            return;
          } else office.push(contest.office.name)
        })
        let eventId = ''
        if (officeevent) {
          let officefilter = contests.find(el=>{
            console.log('here',el)
            return el.office.name.toLowerCase() === officeevent.toLowerCase()})
          if (officefilter) {
            setEvent(officefilter.id)
          }
        }
        setContests(prevContest=>({
          ...prevContest,
          officeList: office, 
          contests: contests
        }))
      }
    }
    } catch(e) {
      console.log("error getting contest List",e, city,dataset)
    }
  }


  const setCity = (city) => {
    console.log('set city')
    setSelectedCity(city)
    setSelectedEvent('')
    getContestList(city)
  }

  const setEvent = (event) => {
    console.log('event', event)
    try {
      setSelectedEvent(event)
    } catch (e) {
      console.log(e)      
    }
  }

  return (
    <div id="widget-main" className={'classes.main h-full p-1'}>
      {data ? 
        <div id="widget-mainContainer" className={'classes.mainContainer max-h-full h-full justify-center relative flex flex-col overflow-hidden'}>
          <div id="selectBox" className={'classes.selectContainer flex flex-col pb-1 gap-1'}>
            <SelectBox selectedCity={selectedCity} cityList={data.cityList} setCity={setCity}/>
            {selectedCity && <EventSelect eventList={selectedContests} setEvent={setEvent} selectedRegion={selectedCity} selectedContest={selectedEvent}/>}
          </div>
          <div className="grow overflow-hidden max-h-full flex flex-col">
          {selectedCity ? 
            <Results selectedCity={selectedCity} results={selectedContests} selectedEvent={selectedEvent}/>  
            : <div style={{paddingLeft: '1%', paddingTop: '10px'}}>Select region above to view results</div>}
            </div>
        </div>
        : 
        <Loading />}
    </div>
  );
}

const Home = () => {
  return (
    <div className='flex flex-col p-5'>
      <Link to="on/2023">Toronto mayoral by-election 2023</Link>
      <Link to="on/2022">ON 2022</Link>
      <Link to="bc/2022">BC 2022</Link>
      <Link to="alberta/2021">Alberta 2021</Link>
      <Link to="quebec/2021">Quebec 2021</Link>
    </div>
  )
}

export default App;
